import api from "../api"
import {Clocks} from "../models/Clocks";

export class ClockService {
    static async getClocksByUserId(userId: number): Promise<Clocks[]> {
        const { data, status } = await api.get(`/clocks/user/${userId}`)
        if (status !== 200) throw new Error("Impossible de récupérer les horodatages de l'utilisateur")
        return data;
    }

    static async createClock(clockData: Clocks): Promise<any> {
        const res = await api.post("/clocks", clockData)
        if (res.status !== 200) throw new Error("Erreur lors de la création de l'horodatage")
        return res.data as any
    }

    static getCurrentWeekRange(): { startWeek: Date; endWeek: Date } {
        const now = new Date();
        const day = now.getDay();
        const diffToMonday = day === 0 ? -6 : 1 - day;

        const startWeek = new Date(now);
        startWeek.setDate(now.getDate() + diffToMonday);
        startWeek.setHours(0, 1, 0, 0);

        const endWeek = new Date(startWeek);
        endWeek.setDate(startWeek.getDate() + 6);
        endWeek.setHours(23, 59, 0, 0);

        return { startWeek, endWeek };
    }

    static getPreviousWeekRange(): { startWeek: Date; endWeek: Date } {
        const now = new Date();
        const day = now.getDay();
        const diffToMonday = day === 0 ? -6 : 1 - day;

        const startWeek = new Date(now);
        startWeek.setDate(now.getDate() + diffToMonday - 7);
        startWeek.setHours(0, 1, 0, 0);

        const endWeek = new Date(startWeek);
        endWeek.setDate(startWeek.getDate() + 6);
        endWeek.setHours(23, 59, 0, 0);

        return { startWeek, endWeek };
    }

    static getDifferenceInHours(start: Date, end: Date): number {
        const diffInMs = end.getTime() - start.getTime()
        return diffInMs / (1000 * 60 * 60);
    }
}
